import React from 'react';
import PropTypes from 'prop-types';
import { Text, AlertModal } from '@cashfree-intl/coherent';

// Constants
import { MODAL_TYPES } from '../constants';

// Components
import AddRecipientModal from './AddRecipientModal';

const Modals = ({
  modalType,
  setModalType,
  setFetchCounter,
  selectedAccountId,
  data,
}) => {
  const handleResponse = modalType => {
    setModalType(modalType);
    setFetchCounter(count => count + 1);
  };

  switch (modalType) {
    case MODAL_TYPES.ADD_RECIPIENT:
      return (
        <AddRecipientModal
          data={data}
          selectedAccountId={selectedAccountId}
          onSubmit={handleResponse}
          onClose={() => setModalType()}
        />
      );

    case MODAL_TYPES.SUCCESS:
      return (
        <AlertModal
          type="success"
          title="Recipient Added Successfully"
          onClose={() => setModalType()}
        >
          <Text as="p" variant="p14" color="bodyLight">
            Notifications will be sent to the recipient.
          </Text>
        </AlertModal>
      );

    case MODAL_TYPES.ERROR:
      return (
        <AlertModal
          type="danger"
          title="Something went wrong. Please try again later."
          onClose={() => setModalType()}
        />
      );
  }
};

Modals.propTypes = {
  modalType: PropTypes.string.isRequired,
  setModalType: PropTypes.func.isRequired,
  setFetchCounter: PropTypes.func.isRequired,
  selectedAccountId: PropTypes.number.isRequired,
  data: PropTypes.object.isRequired,
};

export default Modals;
